import { parseUrl } from 'query-string'

import { REDIRECT_DELAY_MS } from './consts'

export default () => {
  setTimeout(() => {
    const urlParams = parseUrl(window.location.href).query
    window.location.href = `https://${urlParams.target}`
  }, REDIRECT_DELAY_MS)
}
